import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledTableTimes } from './styles/StyledTableTimes';


class TimesHeader extends Component {
  render() {
    const { header1, header2,} = this.props;

    return (
      <StyledTableTimes>
        <table className="table-times">
          <tbody>
            <tr className="table-times-header">
              <td className="table-times-td-time">
                <div className="table-times-div-time">
                  { header1 }
                </div>
              </td>
              <td className="table-times-td-capacity">
                { header2 }
              </td>
              <td className="table-times-td-arrow">
      
              </td>
            </tr>
          </tbody>
        </table>
      </StyledTableTimes>
    );
  }
}


TimesHeader.propTypes = {
  header1: PropTypes.string.isRequired,
  header2: PropTypes.string.isRequired,
};

export default TimesHeader;
